var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDominica(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2d693b",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14 0h2v24h-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8d047",
    d: "M12 0h2v24h-2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 0h2v24h-2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M30 11v2H0v-2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8d047",
    d: "M30 9v2H0V9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30 13v2H0v-2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#c42936",
    d: "M15 6a6 6 0 1 0 0 12 6 6 0 0 0 0-12"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2d693b",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m14.97 6.5.29.72.73-.02-.6.5.28.78-.68-.5-.58.44.19-.74-.6-.42.76-.05zm3.23 1.04-.18.75.6.4-.77.06-.24.8-.26-.81-.73.02.6-.5-.25-.69.65.41zm1 2.04.28.71.73-.02-.59.5.28.78-.69-.5-.57.44.18-.74-.6-.42.77-.05zm.62 2.93-.19.74.6.42-.77.05-.23.8-.26-.81-.73.02.6-.5-.25-.69.65.41zm-2.24 2.04.29.71.73-.02-.6.5.28.78-.68-.5-.58.44.19-.75-.6-.4.77-.06zm-1.99 1.03-.19.74.6.42-.76.05-.24.8-.26-.81-.73.02.6-.5-.25-.69.65.41zm-3.23-1.03.28.71.73-.02-.58.5.24.69-.65-.41-.66.5.26-.8-.6-.42.77-.05zm-1-2.04-.18.74.6.42-.77.05-.23.8-.27-.81-.72.02.59-.5-.25-.69.65.41zm-.62-2.93.29.71.73-.02-.6.5.29.78-.69-.5-.58.44.19-.74-.6-.42.77-.05zm2.24-2.04-.19.75.6.4-.77.06-.23.8-.26-.81-.73.02.6-.5-.25-.69.65.41z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDominica);
export default __webpack_public_path__ + "static/media/dominica.98c3a96c8f22565b0d98ca461a7e779c.svg";
export { ForwardRef as ReactComponent };